export interface SeparatorLineProps {
    margin?: number
    marginLeft?: number
    marginRight?: number
}

export function SeparatorLine(props: SeparatorLineProps) {
    return (
        <div className={`border-t border-neutral-500 ${props.margin != undefined ? "mx-" + props.margin : ""}`}></div>
    )
}